{
  "header": {
    "menu": {
      "developers": "المطورون",
      "advantages": "المميزات",
      "catalogs": "الكتالوجات",
      "functionality": "الخدمات"
    },
    "join": "انضم الآن"
  },
  "content": {
    "header": {
      "buttonTransparent": "عالج طلباتك أسرع بخمس مرات مع Genie Map",
      "title": "خدمة موحدة للوكالات العقارية في جميع أنحاء العالم",
      "description": "خريطة تفاعلية بفلترة متقدمة للبحث السريع عن المشاريع قيد الإنشاء من المطورين ووكالات العقارات، ومولّد كتالوجات بعلامتك التجارية، وأفضل منصة لمكالمات الفيديو مع عملائك، والمزيد من الميزات لعمل مريح وفعّال لوكالتك العقارية.",
      "join": "انضم الآن",
      "learnMore": "اعرف المزيد"
    },
    "developers": {
      "title": "شبكة واسعة من المطورين",
      "description": "في Genie Map، ستجد أكثر من 600 مطور و3200 مشروع عقاري، <br /> جاهز لإضافته <a href='#catalogs'>إلى كتالوجاتك بعلامتك التجارية.</a>"
    },
    "service": {
      "title": "أفضل منصة للوكالات العقارية",
      "description": "نمتلك معرفة شاملة بطبيعة السوق واحتياجات الوسطاء والوكالات. نقوم بجمع المعلومات عن المطورين والمشاريع الجديدة يومياً ونحدّثها بشكل دائم لضمان حصولك على أحدث المعلومات والمشاريع.",
      "item1Title": "نظام التصفية المتقدم",
      "item1Description": "سيساعدك نظام التصفية المتقدم في العثور على المشروع المثالي لعميلك. قم بتطبيق الفلاتر حسب المنطقة، المساحة، المطور، السعر، تاريخ التسليم، حالة الإطلاق أو جاهزية الانتقال، وأكثر من ذلك بكثير.",
      "item2Title": "عمليات الإطلاق القادمة",
      "item2Description": "نقوم بإضافة الإطلاقات الجديدة باستمرار ونزيد عدد المشاريع المعروضة للعملاء. يمكنك بسهولة البدء في جمع بيانات الاهتمام من العملاء قبل موعد الإطلاق الرسمي بوقت طويل.",
      "item3Title": "كتالوج فردي لكل عميل على حدة",
      "item3Description": "يمكن للوسيط إنشاء كتالوج يحتوي على عدة مشاريع للعميل وإرسال ملف واحد فقط يحتوي على جميع المعلومات الضرورية التي تناسب طلب العميل بالكامل.",
      "item4Title": "على علم تام",
      "item4Description": "Genie Map هي قاعدة بيانات شاملة للمطورين والمشاريع في كل منطقة نقوم بتغطيتها. يحتوي كل حي على وصف فريد، مما يسمح للوسطاء بتزويد العملاء بمزيد من المعلومات حول مزايا وميزات منطقة معينة."
    },
    "catalog": {
      "title": "الكتالوجات بعلامتك التجارية",
      "description": "في ٥ ثوانٍ، ستحصل على كتالوج يحمل شعار وكالتك والذي يضم أي مشاريع ووحدات من المطورين.",
      "join": "ابدأ في إنشاء الكتالوجات للعملاء"
    },
    "functionality": {
      "title": "المنصة التي بإمكانها حل جميع مهام الوكالة العقارية",
      "listItem1": "ارتقِ بمواعيدك الشخصية أو عبر الإنترنت مع العملاء إلى مستوى جديد تماماً. على GenieMap، نستخدم شعار وكالتك واسمها التسويقي، بحيث تحمل المنصة شعارك واسمك.",
      "listItem2": "استخدم Genie Map كمنصة تدريب للوسطاء قليلي الخبرة لزيادة وعيهم بالسوق.",
      "block1Title": "تحديث دائم",
      "block1Description": "يتم تحديث خريطتنا يومياً. ستكون على اطلاع دائم بتوفر الوحدات دون الحاجة إلى إجراء مكالمات أو رسائل لا نهاية لها إلى مديري مبيعات المطور.",
      "block2Title": "اجتماعات إلكترونية مريحة",
      "block2Description": "نظم اجتماعاتك عبر الإنترنت، شارك شاشتك، واعرض جميع المعلومات اللازمة مثل المشاريع المتاحة والأحياء والبنية التحتية في واجهة سهلة الاستخدام تحمل شعار شركتك.",
      "block3Title": "وصف الأحياء",
      "block3Description": "استخدم قاعدة بيانات واسعة من أوصاف الأحياء المحلية التي تغطي كل منطقة على المنصة. عزز معرفتك بالسوق وخبرتك الشخصية لتقديم عروض ذات صلة ومطلعة جيدًا للعملاء.",
      "block4Title": "معلومات دقيقة عن كل مشروع",
      "block4Description": "زوّد عميلك بمعلومات شاملة عن أي مشروع يهتم به. أجب عن كل سؤال واحصل على صفقة بيع ناجحة.",
      "block5Title": "قاعدة بيانات تضم جهات اتصال مدير المبيعات",
      "block5Description": "استخدم قاعدة بيانات جهات اتصال مديري المبيعات لزيادة عدد المطورين الذين تعمل وكالتك معهم.",
      "block6Title": "تخصيص شامل",
      "block6Description": "خصص المنصة لك ولعميلك. اختر اللغة، العملة، ووحدات القياس. اجعل بحثك أكثر راحة ودقة."
    },
    "joinForm": {
      "title": "ابدأ في استخدام<br />Genie Map اليوم",
      "description": "اترك طلبًا لربط شركتك بمنصتنا، وسيتصل بك موظفنا على الفور لتوضيح التفاصيل.",
      "name": "الاسم",
      "tel": "رقم الهاتف",
      "position": {
        "name": "المنصب \\ المهنة",
        "select": "تحديد",
        "owner": "مالك \\ مدير الوكالة",
        "broker": "وسيط",
        "developer": "مطور",
        "freelancer": "مستقل",
        "realEstateBuyer": "مشتري عقار"
      },
      "market": {
        "name": "السوق",
        "select": "حدد سوقًا",
        "AE": "🇦🇪 الإمارات العربية المتحدة",
        "TH": "🇹🇭 تايلاند"
      },
      "companyName": "اسم الشركة",
      "privacyPolicy": "أوافق على <a href=\"./privacy-policy.html\" target=\"_blank\">سياسة الخصوصية</a>",
      "join": "اترك طلباً لمعاودة الاتصال"
    },
    "successForm": {
      "title": "شكراً على تقديم الطلب",
      "description": "سنتواصل معك قريباً لتوضيح التفاصيل."
    }
  },
  "footer": {
    "social": {
      "title": "GenieMap على الشبكات الاجتماعية"
    },
    "legalInformation": {
      "title": "تفاصيل الشركة",
      "privacyPolicy": "سياسة الخصوصية"
    },
    "contact": {
      "agencies": {
        "title": "جهات الاتصال للوكالات"
      },
      "developers": {
        "title": "جهات الاتصال للمطورين"
      }
    },
    "address": {
      "title": "عنواننا"
    }
  },
  "cookie": {
    "text": "نحن نستعمل الكوكيز لتحسين تجربة التصفح الخاصة بك. بالنقر على \"أوافق\"، فإنك توافق على استخدام ملفات الكوكيز.",
    "button": "موافق"
  },
  "privacyPolicy": {
    "title": "سياسة معالجة البيانات الشخصية",
    "section1": {
      "title": "1. الأحكام العامة",
      "paragraph1": "تُعَدُّ هذه السياسة الخاصة بمعالجة البيانات الشخصية معدّةً وفقًا لمتطلبات القانون الاتحادي رقم 152-ف.ز. الصادر بتاريخ 27.07.2006 «بشأن البيانات الشخصية» (فيما يلي – قانون البيانات الشخصية) وتحدد إجراءات معالجة البيانات الشخصية والتدابير المتخذة لضمان أمنها من قبل شركة GENIE MAP PORTAL L.L.C (فيما يلي – المشغل).",
      "paragraph2": "1.1. يضع المشغل كأهم هدف وشرط لممارسة نشاطه احترام حقوق وحريات الإنسان والمواطن عند معالجة بياناته الشخصية، بما في ذلك حماية الحقوق في الخصوصية والأسرار الشخصية والعائلية.",
      "paragraph3": "1.2. تنطبق سياسة المشغل هذه بشأن معالجة البيانات الشخصية (المشار إليها فيما يلي – السياسة) على جميع المعلومات التي يمكن للمشغل الحصول عليها عن زوار الموقع geniemap.net."
    },
    "section2": {
      "title": "2. المفاهيم الأساسية المستخدمة في السياسة",
      "paragraph1": "2.1. المعالجة الآلية للبيانات الشخصية – معالجة البيانات الشخصية باستخدام تكنولوجيا الحاسوب.",
      "paragraph2": "2.2. حجب البيانات الشخصية – التوقف المؤقت عن معالجة البيانات الشخصية (باستثناء الحالات التي تكون فيها المعالجة ضرورية لتوضيح البيانات الشخصية).",
      "paragraph3": "2.3. الموقع الإلكتروني – مجموعة المواد الرسومية والمعلوماتية، وكذلك البرامج الحاسوبية وقواعد البيانات التي تضمن إمكانية الاطلاع عليها على شبكة الإنترنت تحت عنوان geniemap.net.",
      "paragraph4": "2.4. نظام معلومات البيانات الشخصية – مجموعة البيانات الشخصية الواردة في قواعد البيانات والتقنيات المعلوماتية والوسائل التقنية التي تضمن معالجتها.",
      "paragraph5": "2.5. إضفاء الطابع غير الشخصي على البيانات الشخصية – الإجراءات التي يصبح بموجبها من المستحيل تحديد هوية البيانات الشخصية المنسوبة إلى مستخدم محدد دون استخدام معلومات إضافية.",
      "paragraph6": "2.6. معالجة البيانات الشخصية – أي إجراء (عملية) أو مجموعة إجراءات (عمليات) تتم بالبيانات الشخصية بغض النظر عن استخدام أدوات الأتمتة، وتشمل الجمع والتسجيل والتصنيف والتجميع والتخزين والتوضيح (التحديث والتعديل) والاستخراج والاستخدام والنقل (التوزيع والتقديم والتوفير) وإضفاء الطابع غير الشخصي والحجب والحذف والإتلاف.",
      "paragraph7": "2.7. المشغل – سلطة حكومية أو بلدية أو شخص اعتباري أو فرد ينظم أو يعالج البيانات الشخصية بصورة مستقلة أو بالاشتراك مع غيره، ويحدد أهداف المعالجة ومجموعة البيانات الشخصية المراد معالجتها والإجراءات (العمليات) المنفذة عليها.",
      "paragraph8": "2.8. البيانات الشخصية – أي معلومات تتعلق مباشرة أو غير مباشرة بمستخدم محدد أو قابل للتحديد لموقع geniemap.net.",
      "paragraph9": "2.9. البيانات الشخصية المصرح بنشرها من قِبَل صاحب البيانات – البيانات الشخصية التي يحق لعدد غير محدود من الأشخاص الاطلاع عليها بموافقة صاحب البيانات وفق الإجراءات المنصوص عليها في قانون البيانات الشخصية (المشار إليها فيما يلي – بيانات مصرح بنشرها).",
      "paragraph10": "2.10. المستخدم – أي زائر للموقع geniemap.net.",
      "paragraph11": "2.11. تقديم البيانات الشخصية – الإجراءات الهادفة إلى الكشف عن البيانات الشخصية لشخص معين أو دائرة معينة من الأشخاص.",
      "paragraph12": "2.12. نشر البيانات الشخصية – أي إجراءات هادفة إلى الكشف عن البيانات الشخصية لدائرة غير محدودة من الأشخاص (نقل البيانات الشخصية) أو الاطلاع عليها من قبل دائرة غير محدودة من الأشخاص، بما في ذلك نشر البيانات في وسائل الإعلام أو وضعها في الشبكات المعلوماتية والاتصالاتية أو توفير الوصول إليها بأي طريقة أخرى.",
      "paragraph13": "2.13. نقل البيانات الشخصية عبر الحدود – نقل البيانات الشخصية إلى إقليم دولة أجنبية إلى سلطة دولة أجنبية أو شخص أجنبي أو جهة اعتبارية أجنبية.",
      "paragraph14": "2.14. إتلاف البيانات الشخصية – أي إجراءات تُفضي إلى إتلاف البيانات الشخصية بشكل دائم مع استحالة استرجاع محتواها في نظام معلومات البيانات الشخصية و/أو إتلاف الوسائط المادية التي تحتوي عليها."
    },
    "section3": {
      "title": "3. الحقوق والواجبات الأساسية للمشغل",
      "paragraph1": "3.1. يحق للمشغل:<br />— الحصول على معلومات ومستندات موثوقة تحتوي على البيانات الشخصية من صاحبها؛<br />— في حال سحب صاحب البيانات موافقته على المعالجة أو تقديمه طلبًا بوقف المعالجة، يحق للمشغل متابعة معالجة البيانات دون موافقة صاحبها إذا وجدت أسس منصوص عليها في قانون البيانات الشخصية؛<br />— تحديد تشكيل قائمة التدابير اللازمة والكافية لتنفيذ الالتزامات المنصوص عليها في قانون البيانات الشخصية والأنظمة القانونية التنفيذية الصادرة بموجبه بصورة مستقلة، ما لم ينص قانون البيانات الشخصية أو قوانين اتحادية أخرى على خلاف ذلك.",
      "paragraph2": "3.2. يلتزم المشغل:<br />— تزويد صاحب البيانات، عند طلبه، بمعلومات تتعلق بمعالجة بياناته الشخصية؛<br />— تنظيم معالجة البيانات الشخصية وفق الإجراءات المنصوص عليها في التشريع الساري لدولة الإمارات العربية المتحدة؛<br />— الاستجابة لطلبات صاحب البيانات أو ممثليه القانونيين وفق متطلبات قانون البيانات الشخصية؛<br />— إبلاغ الجهة المخولة بحماية حقوق صاحب البيانات عند طلبها بالمعلومات اللازمة خلال 30 يومًا من تاريخ الطلب؛<br />— نشر هذه السياسة أو توفير وصول غير مقيد إليها؛<br />— اتخاذ التدابير القانونية والتنظيمية والفنية لحماية البيانات الشخصية من الوصول غير المصرح به أو العرضي، والتعديل، والحجب، والنسخ، والتقديم، والنشر، أو أي أفعال غير قانونية أخرى؛<br />— إيقاف نقل البيانات الشخصية أو توفير الوصول إليها، ووقف المعالجة، وإتلاف البيانات حسب الحالات والإجراءات المنصوص عليها في قانون البيانات الشخصية؛<br />— القيام بالواجبات الأخرى المنصوص عليها في قانون البيانات الشخصية."
    },
    "section4": {
      "title": "4. الحقوق والواجبات الأساسية لأصحاب البيانات الشخصية",
      "paragraph1": "4.1. يحق لأصحاب البيانات الشخصية:<br />— الحصول على معلومات تتعلق بمعالجة بياناتهم الشخصية، باستثناء الحالات المنصوص عليها في القوانين الاتحادية؛<br />— مطالبة المشغل بتوضيح بياناتهم أو حجبها أو إتلافها إذا كانت ناقصة أو قديمة أو غير دقيقة أو حصل عليها دون وجه حق أو غير ضرورية للأغراض المعلنة؛<br />— اشتراط الموافقة المسبقة عند معالجة البيانات الشخصية لأغراض الترويج للسلع أو الأعمال أو الخدمات؛<br />— سحب موافقتهم على معالجة البيانات أو تقديم طلب بوقف المعالجة؛<br />— الطعن أمام الجهة المخولة بحماية حقوق أصحاب البيانات أو أمام القضاء ضد أي إجراءات غير قانونية أو تقاعس من قبل المشغل؛<br />— ممارسة الحقوق الأخرى المنصوص عليها في تشريعات دولة الإمارات العربية المتحدة.",
      "paragraph2": "4.2. يلتزم أصحاب البيانات الشخصية:<br />— تقديم بيانات موثوقة عن أنفسهم للمشغل؛<br />— إبلاغ المشغل بأي تعديلات أو تحديثات لبياناتهم الشخصية.",
      "paragraph3": "4.3. يُعاقب من يقدم للمشغل بيانات كاذبة عن نفسه أو عن غيره دون موافقة صاحب البيانات وفق تشريعات دولة الإمارات العربية المتحدة."
    },
    "section5": {
      "title": "5. مبادئ معالجة البيانات الشخصية",
      "paragraph1": "5.1. تُعالج البيانات الشخصية على أساس قانوني وعادل.",
      "paragraph2": "5.2. تُقتصر معالجة البيانات على تحقيق أهداف محددة ومعلنة ومشروعة، ويُمنع معالجتها لأغراض تتعارض مع هذه الأهداف.",
      "paragraph3": "5.3. يُمنع دمج قواعد بيانات تحتوي على بيانات شخصية تُعالج لأغراض غير متوافقة.",
      "paragraph4": "5.4. تُعالج البيانات الشخصية فقط إذا كانت تلبي أهداف المعالجة.",
      "paragraph5": "5.5. يتناسب محتوى وحجم البيانات الشخصية المعالجة مع الأغراض المعلنة، ويُمنع ازدواجية البيانات بالنسبة لتلك الأغراض.",
      "paragraph6": "5.6. عند معالجة البيانات الشخصية، يضمن المشغل دقة البيانات وكفايتها وملاءمتها لأغراض المعالجة. ويتخذ المشغل التدابير اللازمة أو يضمن اتخاذها لحذف أو توضيح البيانات الناقصة أو غير الدقيقة."
    }
  }
}
